import React, { Component } from 'react';
import { Grid, Image, Modal, Button, Segment, Table, Label } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';

import placeholder from '../assets/profile-placeholder.png';

export default class InmateDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            bookingId: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.inmate != null){
            this.setState({
                modalOpen: true,
                bookingId: nextProps.inmate.ptsBookingID
            }, this.fetchInmateOffenceAndAttachment);
        }
    }

    fetchInmateOffenceAndAttachment() {
        axios.get(`${process.env.REACT_APP_API_URL}/inmate-detail/${this.state.bookingId}`)
        .then((response) => {
            this.setState({
                offences: response.data.offences,
                attachments: response.data.attachments
            });
        }).catch((error) => {
            if (error.response) {
                console.log(error.response);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log(error);
            }
        }).then(() => {});
    }

    render() {
        const displayImage = true;
        const displayText = true;
        let offences = null;
        // let attachments = null;
        let totalBondAmount = 0;
        if (this.state.offences) {
            offences = this.state.offences.map((offence, i) => {
                totalBondAmount += offence.BondAmount;
                return (
                    <Table.Row key={i}>
                        <Table.Cell>{offence.StatuteDescription}</Table.Cell>
                        <Table.Cell>{offence.StatuteLevel}</Table.Cell>
                        <Table.Cell>{offence.ArrestDate ? moment.utc(offence.ArrestDate).format('MM/DD/YYYY') : ''}</Table.Cell>
                        <Table.Cell>{offence.ArrestingAgency}</Table.Cell>
                        <Table.Cell>{offence.IsBondDenied}</Table.Cell>
                        <Table.Cell>${offence.BondAmount}</Table.Cell>
                    </Table.Row>
                );
            });
        }

        // if (this.state.attachments) {
        //     attachments = this.state.attachments.map((attachment, i) => {
        //         return (
        //             <Table.Row key={i}>
        //                 <Table.Cell>{attachments.Description}</Table.Cell>
        //                 <Table.Cell>{attachments.Created}</Table.Cell>
        //                 <Table.Cell>{attachments.FileName}</Table.Cell>
        //             </Table.Row>
        //         );
        //     });
        // }

        let fullName = '';
        if (this.props.inmate && this.props.inmate.FirstName) fullName = this.props.inmate.FirstName;
        if (this.props.inmate && this.props.inmate.MiddleName) fullName += ` ${this.props.inmate.MiddleName}`;
        if (this.props.inmate && this.props.inmate.LastName) fullName += ` ${this.props.inmate.LastName}`;

        return (
            <Modal size={'fullscreen'} dimmer={this.props.dimmer} open={this.state.modalOpen} style={{ position: 'static' }} >
                {this.props.inmate != null &&
                    <Modal.Content image>
                        <Modal.Description>
                            <Segment>
                                <Button positive icon='checkmark' labelPosition='right' content="Close" floated='right'
                                    onClick={() => {
                                        this.setState({ modalOpen: false, offences: null, bookingId: null });
                                        this.props.onClose();
                                    }}
                                />

                                <h2>{ fullName }</h2>
                                <Label horizontal>Booking ID: <Label.Detail>{this.props.inmate.BookingID}</Label.Detail></Label>
                                <Label horizontal color={this.props.inmate.IsBondDenied === false ? 'green' : 'red'}>Bond status: <Label.Detail>{this.props.inmate.IsBondDenied === false ? 'Bondable' : 'Not Bondable'}</Label.Detail></Label>

                                <Grid columns={2} >
                                    <Grid.Column style={{ marginTop: '10px'}} width={6}>
                                     
                                    <div style={{ position: "relative" }}>
            {displayImage && displayText && (
              <p 
                style={{
                  color: "red",
                  position: "absolute",
                  bottom: "0px",
                  zIndex: 999,
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "5px",
                  maxWidth: "300px",
                }}
              >
                All persons are presumed innocent until proven guilty
              </p>
            )}
            {displayImage && (
              <Image wrapped size='medium' src={this.props.inmate.MugShotFileStream ? "data:image/png;base64, " + this.props.inmate.MugShotFileStream : placeholder} />
            )}
          </div>
                                 
                                        

                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Height: </strong>{this.props.inmate.Height}</div>
                                        {/* <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>DOB: </strong>{moment.utc(this.props.inmate.DOB).format('MM/DD/YYYY')}</div> */}
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Age: </strong>{this.props.inmate.Age}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Weight: </strong>{this.props.inmate.Weight}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Eye Color: </strong>{this.props.inmate.EyeColor}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Hair Color: </strong>{this.props.inmate.HairColor}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Gender: </strong>{this.props.inmate.Gender}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Race: </strong>{this.props.inmate.Race}</div>
                                        <div style={{ fontSize: '13px', marginBottom: '10px' }}><strong>Address: </strong>{this.props.inmate.Address}</div>
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column>
                                        <p style={{ backgroundColor: '#f68704', textAlign: 'center', color: '#ffffff', padding: '5px' }}><strong>List of Offenses</strong></p>
                                        <Table celled size='small'>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Statute Description</Table.HeaderCell>
                                                    <Table.HeaderCell>Level</Table.HeaderCell>
                                                    <Table.HeaderCell>Arrest Date</Table.HeaderCell>
                                                    <Table.HeaderCell>Arrest Agency</Table.HeaderCell>
                                                    <Table.HeaderCell>Bond Denied</Table.HeaderCell>
                                                    <Table.HeaderCell>Bond Amount</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {offences}
                                            </Table.Body>
                                            <Table.Footer>
                                                <Table.Row>
                                                    <Table.HeaderCell/> <Table.HeaderCell/> <Table.HeaderCell/> <Table.HeaderCell/> <Table.HeaderCell/>
                                                    <Table.HeaderCell>Sum of bond amount is: ${totalBondAmount}</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Footer>
                                        </Table>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            {/* <Grid>
                                <Grid.Row>
                                    <Grid.Column>
                                        <p style={{ backgroundColor: '#f68704', textAlign: 'center', color: '#ffffff', padding: '5px' }}><strong>List of Attachments</strong></p>
                                        <Table celled>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Description</Table.HeaderCell>
                                                    <Table.HeaderCell>Attach date</Table.HeaderCell>
                                                    <Table.HeaderCell>Attachment</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {attachments}
                                            </Table.Body>
                                        </Table>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid> */}
                        </Modal.Description>
                    </Modal.Content>
                }
                <Modal.Actions>
                    <Button
                        positive
                        icon='checkmark'
                        labelPosition='right'
                        content="Close"
                        onClick={() => {
                            this.setState({ modalOpen: false, offences: null, bookingId: null });
                            this.props.onClose();
                        }}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/InmateDetailModal.js